import { TableCell } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const InventoryDataItem = ({ itemAmount, itemTitle }) => {
  return (
    <TableCell
      data-testid="summary-data-item"
      className="summary-data-item-container"
      style={{padding:"2px", border:"none",top:"-2px" }}
    >
      <div className="summary-data-title">{itemTitle}</div>
      <div className="summary-data">{itemAmount}</div>
    </TableCell>
  );
};

InventoryDataItem.propTypes = {
  itemAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InventoryDataItem;
